export const API_URL = "https://api.mercaio.mercadapp.com.br/"
export const CLIENT_ID = "WX6DyP2sqVdIghayZ5jbC4kp2VpRdHiFZ5oET55mmL8"
export const CLIENT_SECRET = "LlMGM-_Ok14l_BTyAUfLDGpGXif1WwFsKop7xKrREm4"
export const LINX_IO_URL = "https://api.linxio.net/v2"
export const MAKERTEC_IO_URL = "https://api.io.makertec.com.br/v2"